export const SHOWROOM = 'showroom';
export const LOAN_TRACKER = 'loan_tracker';
export const SALES_CHART = 'sales_chart';
